import {
  step1,
  step2,
  step3,
  step4,
  step5,
  androidStep2,
  androidStep3,
  androidStep4,
  androidStep5,
  mtnLogo,
  airtelLogo,
  gloLogo,
  etisalatLogo,
  nepaLogo,
  phNepaLogo,
  egNepaLogo,
  ibNepaLogo,
  dstvLogo,
  gotvLogo,
  startimesLogo,
  showmaxLogo,
  waecLogo,
  necoLogo,
  natebLogo,
} from "@/assets";

import {
  MdLocalPhone,
  MdOutlineLocalPhone,
  MdOutlineWifi,
  MdAccountBox,
  MdKey,
} from "react-icons/md";
import { AiFillThunderbolt, AiOutlineThunderbolt } from "react-icons/ai";
import { FaUserGraduate, FaRegCreditCard } from "react-icons/fa6";
import { IoIosDesktop } from "react-icons/io";
import { GoHistory } from "react-icons/go";
import { ArrowUpDown, Lightbulb } from "lucide-react";
import { HiOutlineLightBulb } from "react-icons/hi2";
import { IoDesktopOutline } from "react-icons/io5";

export const States = [
  {
    name: "Abia",
  },
  {
    name: "Adamawa",
  },
  {
    name: "Akwa Ibom",
  },
  {
    name: "Anambra",
  },
  {
    name: "Bauchi",
  },
  {
    name: "Bayelsa",
  },
  {
    name: "Benue",
  },
  {
    name: "Borno",
  },
  {
    name: "Cross River",
  },
  {
    name: "Delta",
  },
  {
    name: "Ebonyi",
  },
  {
    name: "Edo",
  },
  {
    name: "Ekiti",
  },
  {
    name: "Enugu",
  },
  {
    name: "Gombe",
  },
  {
    name: "Imo",
  },
  {
    name: "Jigawa",
  },
  {
    name: "Kaduna",
  },
  {
    name: "Kano",
  },
  {
    name: "Katsina",
  },
  {
    name: "Kebbi",
  },
  {
    name: "Kogi",
  },
  {
    name: "Kwara",
  },
  {
    name: "Lagos",
  },
  {
    name: "Nasarawa",
  },
  {
    name: "Niger",
  },
  {
    name: "Ogun",
  },
  {
    name: "Ondo",
  },
  {
    name: "Osun",
  },
  {
    name: "Oyo",
  },
  {
    name: "Plateau",
  },
  {
    name: "Rivers",
  },
  {
    name: "Sokoto",
  },
  {
    name: "Taraba",
  },
  {
    name: "Yobe",
  },
  {
    name: "Zamfara",
  },
];

export const iosSteps = [
  {
    title: "Open Safari and Navigate to Billzpay",
    details:
      "Launch Safari on your iOS device. In the address bar, type 'https://billzpay.com.ng'. Tap 'Go' and wait for the page to load completely.",
    image: step1,
  },
  {
    title: "Click on the Share Button",
    details:
      "Once the Billzpay website is loaded, find the Share button (square icon with an upward arrow) at the bottom of the Safari window. Tap it to open the sharing menu.",
    image: step2,
  },
  {
    title: "Select 'Add to Home Screen'",
    details:
      "In the sharing menu, scroll down to find the 'Add to Home Screen' option. It's usually represented by a square icon with a plus sign. Tap on it to proceed.",
    image: step3,
  },
  {
    title: "Confirm the Installation",
    details:
      "A new window will appear allowing you to customize the app icon name. Make any desired changes, then tap the 'Add' button in the top right corner to complete the installation.",
    image: step4,
  },
  {
    title: "Access Billzpay from Your Home Screen",
    details:
      "Exit Safari and find the newly added Billzpay icon on your home screen. Tap it to open Billzpay in a dedicated web-app view for a seamless, app-like experience. Note that an internet connection is required for it to function.",
    image: step5,
  },
];

export const androidSteps = [
  {
    title: "Click on the Three-Dot Menu in Your Browser",
    details:
      "Open your preferred browser (like Chrome) and navigate to the Billzpay website i.e 'https://billzpay.com.ng'. Tap the three-dot menu icon located in the upper right corner of the browser.",
    image: androidStep2,
  },
  {
    title: "Select 'Add to Home Screen/Install App'",
    details:
      "In the dropdown menu that appears, look for the option labeled 'Install app.' Tap on it to continue the installation process.",
    image: androidStep3,
  },
  {
    title: "Confirm the Installation",
    details:
      "A pop-up will appear, prompting you to confirm the installation. Review the details and then click the 'Install/Add to Home screen' button to proceed.",
    image: androidStep4,
  },
  {
    title: "Access Billzpay from Your Home Screen",
    details:
      "Once the installation is complete, you’ll find the Billzpay icon on your home screen! Tap it anytime to quickly access the website as if it were a native app.",
    image: androidStep5,
  },
];

export const remoteAddress = "https://backend.billzpay.com.ng";

export const sideNav = [
  { route: "buy-airtime", name: "Get Airtime", icon: MdOutlineLocalPhone },
  { route: "buy-data", name: "Buy Data", icon: MdOutlineWifi },

  {
    route: "buy-electricity-bills",
    name: "Buy Electricity Bills",
    icon: AiOutlineThunderbolt,
  },
  {
    route: "buy-cable-subscription",
    name: "Cable Subscription",
    icon: IoIosDesktop,
  },
];

export const networkLogo = [
  {
    img: mtnLogo,
    name: "mtn",
  },
  {
    img: airtelLogo,
    name: "airtel",
  },
  {
    img: etisalatLogo,
    name: "9mobile",
  },
  {
    img: gloLogo,
    name: "glo",
  },
];

export const beneCategory = [
  {
    title: "Data & Airtime",
    description: "Airtel, MTN, 9mobile, Glo",
    icon: ArrowUpDown,
    type: "phone",
    color: "bg-green-700/90",
  },
  {
    title: "Electricity",
    description: "EKEDC, IKEDC, PHED,",
    icon: HiOutlineLightBulb,
    type: "meter",
    color: "bg-purple-500/90",
  },
  {
    title: "Cable Subscription",
    description: "DSTV, GOTV, SHOWMAX",
    icon: IoDesktopOutline,
    type: "iuc",
    color: "bg-orange-500/90",
  },
];

export const tiles = [
  { name: "Airtime", icon: MdLocalPhone, route: "buy-airtime" },
  { name: "Data", icon: MdOutlineWifi, route: "buy-data" },
  {
    name: "Electricity",
    icon: HiOutlineLightBulb,
    route: "buy-electricity-bills",
  },
  { name: "RSLT_Checker", icon: FaUserGraduate, route: "buy-exam-pins" },
  {
    name: "Cable Sub",
    icon: IoDesktopOutline,
    route: "buy-cable-subscription",
  },
  { name: "History", icon: GoHistory, route: "transactions" },
];

export function checkNumber(n = "") {
  const number = n.replace("+234", "");
  for (var telco in numberPrefix) {
    const parsed =
      number[0] == "0" ? number.substring(1, number.length) : number;
    if (numberPrefix[telco].some((n) => parsed.startsWith(n))) {
      return telco;
    }
  }
  return false;
}

export const selectNetwork = [
  { id: 1, name: "mtn", display: "MTN" },
  { id: 4, name: "airtel", display: "Airtel" },
  { id: 2, name: "glo", display: "Glo" },
  { id: 3, name: "9mobile", display: "9Mobile" },
];

export const numberPrefix = {
  mtn: [
    "803",
    "806",
    "703",
    "903",
    "906",
    "806",
    "706",
    "813",
    "810",
    "814",
    "816",
    "913",
    "916",
  ],
  glo: ["805", "705", "905", "807", "815", "811", "915"],
  airtel: ["802", "902", "701", "808", "708", "812", "901", "907", "912"],
  "9mobile": ["809", "909", "817", "818", "908"],
  "": [],
};

export const electricityLogo = [
  {
    img: nepaLogo,
  },
  {
    img: phNepaLogo,
  },
  {
    img: egNepaLogo,
  },
  {
    img: ibNepaLogo,
  },
];

export const discoName = [
  {
    id: 1,
    name: "Ikeja Electricity",
  },
  {
    id: 2,
    name: "Eko Electricity",
  },
  {
    id: 3,
    name: "Kano Electricity",
  },
  {
    id: 4,
    name: "Port Harcourt Electricity",
  },
  {
    id: 5,
    name: "Jos Electricity",
  },
  {
    id: 6,
    name: "Ibadan Electricity",
  },
  {
    id: 7,
    name: "Kaduna Electricity",
  },
  {
    id: 8,
    name: "Abuja Electricity",
  },
  {
    id: 9,
    name: "Enugu Electricity",
  },
  {
    id: 10,
    name: "Benin Electricity",
  },
];

export const meterType = [
  {
    id: 1,
    name: "Prepaid",
  },
  {
    id: 2,
    name: "Postpaid",
  },
];

export const cableLogo = [
  {
    id: 1,
    img: dstvLogo,
  },
  {
    id: 3,
    img: startimesLogo,
  },
  {
    id: 2,
    img: gotvLogo,
  },
  {
    id: 4,
    img: showmaxLogo,
  },
];
export const cableName = [
  {
    id: 1,
    name: "DSTV",
  },
  {
    id: 2,
    name: "STARTIME",
  },
  {
    id: 3,
    name: "GOTV",
  },
  {
    id: 4,
    name: "Showmax",
  },
];

export const schoolLogo = [
  {
    img: waecLogo,
  },
  {
    img: necoLogo,
  },
  {
    img: natebLogo,
  },
];

export const examType = [
  {
    id: 1,
    name: "WAEC",
  },
  {
    id: 2,
    name: "NECO",
  },
  {
    id: 3,
    name: "NABTEB",
  },
];

export const settingsNav = [
  {
    name: "General",
    icon: MdAccountBox,
  },
  {
    name: "Payment",
    icon: FaRegCreditCard,
  },
  {
    name: "Change Password",
    icon: MdKey,
  },
  {
    name: "Change Transaction Pin",
    icon: MdKey,
  },
];
